import { useEffect, useRef, useCallback } from "react";
import { useLocation } from "react-router-dom";
import { FilterParamsItem, GlobalSearchParams, useConfigStore, useNonPersistentFilterItemsStore,NonConfigStore } from "../assets/config";


interface AfterHistoryChangeMessage {
  type: "afterHistoryChange";
  data: { pathname: string; moduleName?: string };
}
type PostMessage = AfterHistoryChangeMessage;

interface GlobalLanguageChangeMessage {
  type: "globalLanguageChange";
  data: "en" | "zh" | "jp";
}
interface GlobalFilterChangeMessage {
  type: "globalFilterChange";
  data: FilterParamsItem[];
}
interface GlobalSearchChangeMessage {
  type: "globalSearchChange";
  data: GlobalSearchParams;
}

type ReceiveMessageEvent = {
  data:
    | GlobalLanguageChangeMessage
    | GlobalFilterChangeMessage
    | GlobalSearchChangeMessage
};

export const useUrfPostEvents = () => {
  const location = useLocation();
  
  const postMessage = useCallback((message: PostMessage) => {
    if (window.parent !== window) {
      window.parent.postMessage(
        message,
        `https://${process.env.REACT_APP_STG_DOMAIN}`
      );
    }
  }, []);

  useEffect(() => {
    postMessage({
      type: "afterHistoryChange",
      data: {
        pathname: location.pathname,
        moduleName: "",
      },
    });
  }, [location.pathname, postMessage]);
};

export const useUrfReceiveEvents = () => {
  const [updateLanguage] = useConfigStore((state) => [
    // state.language,
    state.updateLanguage,
  ]);
  const languageRef = useRef<string | null>(null);
  const [updateFilter, updateSearch] = useNonPersistentFilterItemsStore(
    (state) => [state.updateFilter, state.updateSearch]
  );

  //Scenes：If the subapplication's route uses asynchronous loading and a request is made during loading.
  //Problem：Relying solely on the iframe's onLoad event may not ensure that the subapplication loads fully.
  //Solution: Put this hook in App.tsx
  const receiveMessage = (event: ReceiveMessageEvent) => {
    // need to use environment variables
    // if (event.origin !== "https://app.devsecops.freyafusion.com") return;
    // console.log('urf event: ',event);
    
    switch (event.data?.type) {
      case "globalLanguageChange": {
        const curLanData = event.data;
        console.log("globalLanguageChange event.data: ", event.data);
        if (["en", "jp"].includes(curLanData.data)) {
          languageRef.current = curLanData.data;
          updateLanguage(curLanData.data);
        } else {
          languageRef.current = "en";
          updateLanguage("en");
        }
        break;
      }
      case "globalFilterChange": {
        console.log("globalFilterChange event.data: ", event.data);
        //@ts-ignore
        updateFilter(event.data.data);
        break;
      }
      case "globalSearchChange":
        console.log("globalSearchChange event.data: ", event.data);
        if(updateSearch){
        updateSearch(event.data.data);
        }
        break;
      
      default:
        break;
    }
  };
  useEffect(() => {
    window.addEventListener("message", receiveMessage, false);
    const timeoutId = setTimeout(() => {
      if (!languageRef.current) {
        updateLanguage("en");
      }
    }, 2000);
    return () => {
      window.removeEventListener("message", receiveMessage);
      clearTimeout(timeoutId);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
